import { FlightGenerationParams } from './../objects/flightGenerationParams';
import { cloneDeep } from 'lodash';
import { FlightSerie } from './../objects/flightSerie';
import { FlightHeaderParams } from '../objects/flightHeaderParams';
import { addDays, differenceInDays } from 'date-fns';

export const generateFlightSeries = (flights_generations_params: FlightGenerationParams[], flight_param: FlightHeaderParams): {flight_series: FlightSerie[], start_date: Date | null} => {
    const flight_series: FlightSerie[] = [];
    flights_generations_params.forEach((flight_generation_params) => {
        const { start_date, end_date, is_daily, days, frequency } = flight_generation_params;
        if (start_date && end_date) {
            if (is_daily) {
                const date = cloneDeep(start_date);
                while (date <= end_date) {
                    // On vérifie que le jour de la semaine est bien sélectionné
                    const daysDifference = differenceInDays(date, flights_generations_params[0].start_date as Date);
                    if (days.includes(date.getDay() as 0 | 1 | 2 | 3 | 4 | 5 | 6)) {
                        flight_series.push({
                            date: cloneDeep(date),
                            total_stock: flight_param.total_stock,
                            total_stock_error: '',
                            pnr_number: '',
                            pnr_number_error: '',
                            purchase_price_adult: flight_param.purchase_price_adult,
                            purchase_price_infant: flight_param.purchase_price_infant,
                            purchase_price_child: flight_param.purchase_price_child,
                            price_adult: flight_param.price_adult,
                            price_infant: flight_param.price_infant,
                            price_child: flight_param.price_child,
                            taxes_adult: flight_param.taxes_adult,
                            taxes_infant: flight_param.taxes_infant,
                            taxes_child: flight_param.taxes_child,
                            purchase_price_adult_error: '',
                            purchase_price_infant_error: '',
                            purchase_price_child_error: '',
                            price_adult_error: '',
                            price_infant_error: '',
                            price_child_error: '',
                            taxes_adult_error: '',
                            taxes_infant_error: '',
                            taxes_child_error: '',
                            retrocession_date_date_error: '',
                            retrocession_date_date: flight_param.retrocession_date_date? addDays(flight_param.retrocession_date_date, daysDifference): null,
                            retrocession_date_type: flight_param.retrocession_date_type,
                            retrocession_date_number: flight_param.retrocession_date_number,
                            circuit_list: flight_param.circuit_list,
                            target: flight_param.target,
                        });
                    }
                    date.setDate(date.getDate() + 1);
                }
            } else {
                // Si la fréquence est autre, on itère sur les jours d'intervalle
                const date = cloneDeep(start_date);
                while (date <= end_date) {
                    // On vérifie que la date est bien comprise entre les dates de départ et de fin
                    const daysDifference = differenceInDays(date, flights_generations_params[0].start_date as Date);
                    if (date >= start_date && date <= end_date) {
                        flight_series.push({
                            date: cloneDeep(date),
                            total_stock: flight_param.total_stock,
                            total_stock_error: '',
                            pnr_number: '',
                            pnr_number_error: '',
                            purchase_price_adult: flight_param.purchase_price_adult,
                            purchase_price_infant: flight_param.purchase_price_infant,
                            purchase_price_child: flight_param.purchase_price_child,
                            price_adult: flight_param.price_adult,
                            price_infant: flight_param.price_infant,
                            price_child: flight_param.price_child,
                            taxes_adult: flight_param.taxes_adult,
                            taxes_infant: flight_param.taxes_infant,
                            taxes_child: flight_param.taxes_child,
                            purchase_price_adult_error: '',
                            purchase_price_infant_error: '',
                            purchase_price_child_error: '',
                            price_adult_error: '',
                            price_infant_error: '',
                            price_child_error: '',
                            taxes_adult_error: '',
                            taxes_infant_error: '',
                            taxes_child_error: '',
                            retrocession_date_date_error: '',
                            retrocession_date_date: flight_param.retrocession_date_date? addDays(flight_param.retrocession_date_date, daysDifference): null,
                            retrocession_date_type: flight_param.retrocession_date_type,
                            retrocession_date_number: flight_param.retrocession_date_number,
                            circuit_list: flight_param.circuit_list,
                            target: flight_param.target,
                        });
                    }
                    date.setDate(date.getDate() + Number(frequency === '' ? 1 : frequency));
                }
            }
        }
    });
    flight_series.sort((a, b) => a.date.getTime() - b.date.getTime());
    return { flight_series, start_date: flight_series.length > 0 ? flight_series[0].date : null };
};